// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"modal_modalWrapper__2lkWV","modal":"modal_modal__29Vfo","fadeInDown":"modal_fadeInDown__y2dGs","btnClose":"modal_btnClose__1YYK9"};